import {CommonModule} from '@angular/common';
import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {RouterModule} from '@angular/router';
import {NxHeaderModule} from '@aposin/ng-aquila/header';
import {NxLinkModule} from '@aposin/ng-aquila/link';
import {TranslateModule} from '@ngx-translate/core';
import {HeaderEnum} from '../../../enums/routes-header.enum';
import {RoutingEnum} from '../../../enums/routing.enum';
import {PageTypeService} from '../../../services/page-type/page-type.service';
@Component({
  selector: 'fq-header',
  imports: [NxHeaderModule, TranslateModule, NxLinkModule, CommonModule, RouterModule],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnChanges {
  content: Record<string, any> | null = null;
  @Input() headerType = HeaderEnum.homepage;
  headerToGet: string = this.headerType;
  linkHeader: string =
    this.headerType === HeaderEnum.energia ? RoutingEnum.Energia : RoutingEnum.homepage;

  constructor(private pageTypeService: PageTypeService) {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes['headerType'] &&
      changes['headerType'].previousValue !== changes['headerType'].currentValue
    ) {
      this.headerToGet = this.headerType;
      this.linkHeader =
        this.headerType === HeaderEnum.energia ? RoutingEnum.Energia : RoutingEnum.homepage;
    }
  }
}
